import { createWebHistory, createRouter } from "vue-router";
// import axios from "axios";
import routes from "./routes";
// import appConfig from "../../app.config";
// import store from "@/state/store";
import { publicPath } from "../../vue.config";

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH),
  base: publicPath,
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

const nextFactory = function (context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;
  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
};

router.beforeEach((to, from, next) => {
  const reqLogout = to.matched.some((record) => record.meta.reqLogout); // false
  const authRequired = to.matched.some((record) => record.meta.authRequired); // false
  const reqToken = !!localStorage.getItem("token"); // false
  if (to.path === '/collective-payment/download-pdf/') {
    localStorage.setItem('isLoginQR', true);
    localStorage.setItem('queryPdf', JSON.stringify(to.query));
  }

  const isMiddleware = to.matched.some((record) => record.meta.middleware); // false
  if (isMiddleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  }

  if (authRequired === true) {
    if (reqToken === false) {
      next("/login");
    } else {
      next();
    }
  } else {
    // if reqAuth = false
    // eslint-disable-next-line no-lonely-if
    if (reqToken === true && reqLogout === true) {
      next("/");
    } else {
      next();
    }
  }


  // if(removeMerchantId === true) {
  //   localStorage.removeItem('merchantId')
  // }

  // if(removeStoreId === true) {
  //   localStorage.removeItem('storeId')
  // }
});

export default router;
